import {AuthConfig} from 'angular-oauth2-oidc';
import {environment} from '../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.stsAuthority,
  redirectUri: window.location.origin,
  clientId: environment.stsClientId,
};
